export const ALL_INCOME_REQUEST = 'ALL_INCOME_REQUEST'
export const ALL_INCOME_SUCCESS = 'ALL_INCOME_SUCCESS'
export const ALL_INCOME_FAIL = 'ALL_INCOME_FAIL'
export const ALL_INCOME_RESET = 'ALL_INCOME_RESET'

export const MONTHLY_INCOME_REQUEST = 'MONTHLY_INCOME_REQUEST'
export const MONTHLY_INCOME_SUCCESS = 'MONTHLY_INCOME_SUCCESS'
export const MONTHLY_INCOME_FAIL = 'MONTHLY_INCOME_FAIL'
export const MONTHLY_INCOME_RESET = 'MONTHLY_INCOME_RESET'

export const YEARLY_INCOME_REQUEST = 'YEARLY_INCOME_REQUEST'
export const YEARLY_INCOME_SUCCESS = 'YEARLY_INCOME_SUCCESS'
export const YEARLY_INCOME_FAIL = 'YEARLY_INCOME_FAIL'
export const YEARLY_INCOME_RESET = 'YEARLY_INCOME_RESET'

export const ALL_SALARY_REQUEST = 'ALL_SALARY_REQUEST'
export const ALL_SALARY_SUCCESS = 'ALL_SALARY_SUCCESS'
export const ALL_SALARY_FAIL = 'ALL_SALARY_FAIL'
export const ALL_SALARY_RESET = 'ALL_INCOME_RESET'
